import { render, staticRenderFns } from "./TiposAnexo.vue?vue&type=template&id=6e0a75cd"
import script from "./TiposAnexo.vue?vue&type=script&lang=ts"
export * from "./TiposAnexo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports